'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Select = function (_React$Component) {
  (0, _inherits3.default)(Select, _React$Component);

  function Select() {
    (0, _classCallCheck3.default)(this, Select);
    return (0, _possibleConstructorReturn3.default)(this, (Select.__proto__ || (0, _getPrototypeOf2.default)(Select)).apply(this, arguments));
  }

  (0, _createClass3.default)(Select, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          onChange = _props.onChange,
          name = _props.name;


      if (onChange) {
        onChange({ name: name, value: this.refs.select.value, currentTarget: { value: this.refs.select.value, name: name } });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var selectAttrs = {};
      if (this.props.onChange) selectAttrs.onChange = this.props.onChange;
      if (this.props.form) selectAttrs.form = this.props.form;
      if (this.props.name) selectAttrs.name = this.props.name;
      if (this.props.value) selectAttrs.value = this.props.value;
      if (this.props.disabled) selectAttrs.disabled = this.props.disabled;

      var styles = require('./Select.scss');

      var classes = styles.Select;

      return _react2.default.createElement(
        'div',
        { className: classes.concat(" " + (this.props.className || "")) },
        _react2.default.createElement(
          'select',
          (0, _extends3.default)({}, selectAttrs, { ref: 'select' }),
          this.props.children
        ),
        _react2.default.createElement('i', { className: 'fa fa-caret-down ' + styles['Select__arrow-icon'] })
      );
    }
  }]);
  return Select;
}(_react2.default.Component);

exports.default = Select;


Select.propTypes = {
  name: _react2.default.PropTypes.string,
  disabled: _react2.default.PropTypes.bool,
  value: _react2.default.PropTypes.string,
  form: _react2.default.PropTypes.string,
  className: _react2.default.PropTypes.string,
  onChange: _react2.default.PropTypes.func
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Select/Select.jsx
// module id = 2672
// module chunks = 0